// extracted by mini-css-extract-plugin
export default {"container":"Table_container__idHj+","table":"Table_table__-mYSe"};